
























































































































import Vue from "vue";
import {
  ref,
  defineComponent,
  computed,
  onMounted
} from "@vue/composition-api";
import { useGetters, useActions } from "vuex-composition-helpers";
import PrimaryContentBody from "@/vue/layouts/PrimaryContentBody.vue";
import { capitalize } from "@/ts/functions/vueFilters";
import useRouter from "vue-router";

import { useInputRules } from "@/ts/functions/composition/inputRules";
import store from '@/ts/store';

export default defineComponent({
  name: "Home",

  components: {
    PrimaryContentBody
  },

  setup(props, { root, refs }) {
    var { SEND_REGISTER_REQUEST } = useActions({
      SEND_REGISTER_REQUEST: "auth/SEND_REGISTER_REQUEST"
    } as any);
    var { errors } = useGetters({ errors: "app/errors" } as any);

    onMounted(() => {
      root.$store.commit("app/setErrors", {});
    });

    var valid = ref(false);
    var form = ref({
      name: "",
      last_name: "",
      email: "",
      password: "",
      password_confirmation: "",
      locale: store.state.app.locale
    });
    var show_password = ref(false);
    var loading = ref(false);

    const firstNameLabel = computed(
      () =>
        capitalize(root.$t("first name")) + " / " + capitalize(root.$t("alias"))
    );

    const lastNameLabel = computed(
      () =>
        capitalize(root.$t("last name")) + " (" + root.$t("form.optional") + ")"
    );

    const rules = ref({
      email: useInputRules().email,
      required: useInputRules().required,
      min: useInputRules().min,
      match: useInputRules().match
    });

    const refForm = computed(
      () => refs.registerForm as Vue & { validate: () => boolean }
    );

    const register = () => {
      if (refForm.value.validate()) {
        loading.value = true;
        SEND_REGISTER_REQUEST(form.value)
          .then(() => {
            root.$router.push({ name: "Home" }).catch(() => {});
          })
          .catch(() => {
            loading.value = false;
          });
      }
    };

    return {
      errors,
      valid,
      form,
      show_password,
      loading,
      firstNameLabel,
      lastNameLabel,
      rules,
      register
    };
  }
});
